"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightMini } from "@medusajs/icons";
import { Text, clx } from "@medusajs/ui";
import { Fragment, useState } from "react";
import LocalizedClientLink from "@modules/common/components/localized-client-link";
export type NavMenuLink = {
  id: string;
  name: string;
  href?: string | null;
  target?: string;
  isExternal?: boolean;
};
export type NavCategory = NavMenuLink & {
  subcategories?: NavMenuLink[];
};
export const FALLBACK_SIDE_MENU_ITEMS: NavCategory[] = [{
  id: "home",
  name: "Inicio",
  href: "/"
}, {
  id: "shop",
  name: "Tienda",
  href: "/store"
}, {
  id: "account",
  name: "Cuenta",
  href: "/account"
}, {
  id: "cart",
  name: "Carrito",
  href: "/cart"
}];
const SideMenu = t0 => {
  const $ = _c(23);
  const {
    categories
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [openIndexes, setOpenIndexes] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = i => {
      setOpenIndexes(s => ({
        ...s,
        [i]: !s[i]
      }));
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleIndex = t2;
  const [open, setOpen] = useState(false);
  const renderMenuLink = _temp;
  const toTestId = _temp2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button type="button" data-testid="nav-menu-button" className="h-10 w-10 inline-flex items-center justify-center leading-none cursor-pointer touch-manipulation text-gray-700 transition-colors active:text-black focus:outline-none" onClick={t3}><svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg><span className="sr-only">Menu</span></button>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/30 backdrop-blur-sm" /></Transition.Child>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><Dialog.Title className="text-[22px] font-semibold tracking-tight text-slate-900">Menu</Dialog.Title></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpen(false);
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="sr-only">Cerrar</span>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <header className="flex items-start justify-between border-b border-slate-200 px-6 pb-6 pt-6">{t7}<button type="button" onClick={t8} className="rounded-full p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700" aria-label="Close menu">{t9}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg></button></header>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const menuCategories = categories && categories.length ? categories : FALLBACK_SIDE_MENU_ITEMS;
  let t11;
  if ($[10] !== menuCategories || $[11] !== openIndexes) {
    let t12;
    if ($[13] !== openIndexes) {
      t12 = (category, idx) => {
        const hasSubs = !!category.subcategories && category.subcategories.length > 0;
        const hasNavigableHref = Boolean(category.href) && category.href !== "#";
        const renderCategoryLabel = () => {
          if (hasSubs && !hasNavigableHref) {
            return <button type="button" className={clx("text-3xl leading-10 hover:text-ui-fg-disabled", "text-left")} onClick={() => toggleIndex(idx)} data-testid={`${toTestId(category.name)}-toggle`} aria-expanded={!!openIndexes[idx]}>{category.name}</button>;
          }
          return renderMenuLink(category, {
            className: "text-3xl leading-10 hover:text-ui-fg-disabled",
            onClick: () => setOpen(false),
            testId: `${toTestId(category.name)}-link`
          });
        };
        return <li key={category.id} className="w-full"><div className="flex items-center justify-between w-full">{renderCategoryLabel()}{hasSubs && <button type="button" aria-expanded={!!openIndexes[idx]} onClick={() => toggleIndex(idx)} className="ml-2" data-testid={`mobile-toggle-${category.name.toLowerCase().replace(/\s+/g, "-")}`}><ArrowRightMini className={clx("transition-transform duration-150", openIndexes[idx] ? "rotate-90" : "")} /></button>}</div>{hasSubs && openIndexes[idx] && <ul className="mt-2 pl-4 flex flex-col gap-2">{category.subcategories.map(sub => <li key={sub.id}>{renderMenuLink(sub, {
                className: "text-lg leading-8 hover:text-ui-fg-disabled",
                onClick: () => setOpen(false),
                testId: `mobile-${toTestId(sub.name)}-link`
              })}</li>)}</ul>}</li>;
      };
      $[13] = openIndexes;
      $[14] = t12;
    } else {
      t12 = $[14];
    }
    t11 = menuCategories.map(t12);
    $[10] = menuCategories;
    $[11] = openIndexes;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = t11;
  let t13;
  if ($[15] !== t12) {
    t13 = <div className="flex-1 overflow-y-auto px-6 pb-6 pt-6"><ul className="flex flex-col gap-6 items-start justify-start">{t12}</ul></div>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex flex-col gap-y-5 border-t border-gray-100 px-6 pt-5 pb-8"><Text className="txt-compact-small text-gray-400">© 2026 Lealti – Todos los derechos reservados</Text></div>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t13) {
    t15 = <Dialog as="div" className="relative z-[70]" onClose={t5}>{t6}<div className="fixed inset-y-0 left-0 flex max-w-full"><Transition.Child as={Fragment} enter="transform transition ease-out duration-200" enterFrom="-translate-x-full" enterTo="translate-x-0" leave="transform transition ease-in duration-150" leaveFrom="translate-x-0" leaveTo="-translate-x-full"><Dialog.Panel className="pointer-events-auto flex h-full w-screen max-w-[420px] flex-col bg-white shadow-[0_32px_80px_rgba(15,23,42,0.18)]"><div className="flex flex-col h-full">{t10}{t13}{t14}</div></Dialog.Panel></Transition.Child></div></Dialog>;
    $[18] = t13;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== open || $[21] !== t15) {
    t16 = <div className="flex items-center">{t4}<Transition show={open} as={Fragment}>{t15}</Transition></div>;
    $[20] = open;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  return t16;
};
export default SideMenu;
function _temp(item, t0) {
  const {
    className,
    onClick,
    testId
  } = t0;
  if (!item.href) {
    return <span className={className}>{item.name}</span>;
  }
  if (item.isExternal) {
    return <a href={item.href} className={className} target={item.target ?? "_blank"} rel={item.target === "_blank" ? "noreferrer" : undefined} onClick={onClick} data-testid={testId}>{item.name}</a>;
  }
  return <LocalizedClientLink href={item.href} className={className} onClick={onClick} data-testid={testId} target={item.target}>{item.name}</LocalizedClientLink>;
}
function _temp2(value) {
  return value.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9_-]/g, "");
}